<!-- error message -->
<div *ngIf="isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
      <i class="icon-error"></i>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>

  </div>
</div>
<div  *ngIf="!isErrorMessage">
  <h2 class="sectionTitle">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.CIRCULARS_REPORT_NAME' | translate }}</h2>
  <div class="services-filter">
    <div class="form-container">
      <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
  
  <!-- Creation Date From -->
      <div class="form-group">
        <label
          for="txtCreationDateFrom">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_FROM' | translate}}</label>
        <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" autocomplete="off"
          #input="bsDatepicker" [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'
          [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
        <div class="red" *ngIf="showFromDateGreaterThanTodayDateMessage">
          {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
        </div>
        <div class="red" *ngIf="showFromDateGreaterThanToDateMessage">
          {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
        </div>
      </div>
      <!-- Creation Date To -->
      <div class="form-group">
        <label
          for="txtCreationDateTo">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_TO' | translate}}</label>
        <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" autocomplete="off"
          #input="bsDatepicker" [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'
          [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
      </div>
  <!-- Request Status -->
      <div class="form-group">
        <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
        <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="statusId">
          <option value="">--- {{'SHARED.AllStatuses' | translate}} ---</option>
          <option value="1">All New Requests</option>
          <option *ngFor="let status of statusesList" value="{{status.Id}}">
            {{currentLanguage == "Ar" ? status.StatusAR : status.StatusEN}}
          </option>
        </select>
      </div>
      <!-- Request Number -->
      <div class="form-group">
        <label for="txtRequestNumber">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.RequestNumber' | translate}}</label>
        <input type="text" class="form-control" [(ngModel)]="requestNumber" autocomplete="off">
      </div>
  
      <!-- Rebate File Number -->
      <div class="form-group">
        <label for="txtRebateFileNumber">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.RebateFileNumber' | translate}}</label>
        <input type="text" class="form-control" [(ngModel)]="rebateFileNumber" autocomplete="off">
      </div>
      
      
        <!-- IMO -->
      <div class="form-group">
        <label for="txtImo">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.Imo' | translate}}</label>
        <input type="text" class="form-control" [(ngModel)]="imo" autocomplete="off">
      </div>
      <!-- Sailing Date From -->
      <div class="form-group">
        <label
          for="txtSailingDateFrom">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.SailingDateFrom' | translate}}</label>
        <input class="form-control" id="txtSailingDateFrom" name="txtSailingDateFrom" autocomplete="off"
          #input="bsDatepicker" [(ngModel)]="sailingDateFrom" bsDatepicker [minDate]='null'
          [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
      </div>

      <!-- Sailing Date To -->
      <div class="form-group">
        <label
          for="txtSailingDateTo">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.SailingDateTo' | translate}}</label>
        <input class="form-control" id="txtSailingDateTo" name="txtSailingDateTo" autocomplete="off"
          #input="bsDatepicker" [(ngModel)]="sailingDateTo" bsDatepicker [minDate]='null'
          [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
      </div>
  
      <!-- Circular Number -->
      <div class="form-group">
        <label for="txtCircular">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.CircularNo' | translate}}</label>
        <select class="form-control" id="txtCircular" name="txtCircular" [(ngModel)]="circularId" (change)="onCircularLookupSelect()">
          <option value="" selected>{{'Choose'| translate}}</option>
          <option *ngFor="let circular of circulars" [value]="circular?.Id">
            {{circular?.CircularNo}} - {{circular?.Symbol}}
          </option>
        </select>
      </div>

      <!-- Percentage-->
      <div class="form-group">
        <label for="txtRebatePercentage">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.RebatePercentage' | translate}}</label>
        <select class="form-control" id="txtRebatePercentage" name="txtRebatePercentage" [(ngModel)]="rebatePercentageValue">
          <option value="" selected>{{'Choose'| translate}}</option>
          <option *ngFor="let percentage of uniquePercentages" [value]="percentage?.PercentageValue">
            {{percentage?.PercentageValue}}
          </option>
        </select>
      </div>
      <!-- Ship Type -->
      <div class="form-group">
          <label for="shipTypeId">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.ShipType' | translate}}</label>
          <select [(ngModel)]="shipTypeId" class="form-control" id="ddlVesselTypeId">
            <option value="" selected>{{'Choose'| translate}}</option>
            <option *ngFor="let vesselType of vesselCircularsTypes" [value]="vesselType?.VesselTypeId" >
                  {{vesselType?.NameEN}}
              </option>
          </select>
      </div>
  
  <!-- Ship Name  -->
  <div class="form-group">
    <label for="txtShipName">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.VesselName' | translate}}</label>
    <input type="text" class="form-control" [(ngModel)]="shipName" autocomplete="off">
  </div>
  
  <!-- Operator Name  -->
  <!-- <div class="form-group">
      <label for="txtOperatorName">Agent Name</label>
      <input type="text" class="form-control" [(ngModel)]="userName" autocomplete="off">
    </div> -->
      <div class="form-group">
        <label for="txtUserName">{{ 'SHARED.REPORTS.LONGHAUL_OBJECT.OperatorName' | translate}}</label>
        <div class="ng-autocomplete">
          <ng-autocomplete [data]="agentsNamesList" [searchKeyword]="keyword" autocomplete="off"
            (selected)='selectAgentNameEvent($event)' (inputChanged)='onAgentsNamesSearchChange($event)'
            (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [minQueryLength]="autoCompleteMinQueryLength"
            [notFoundTemplate]="notFoundTemplate" [isLoading]="isAutoCompleteLoading" [(ngModel)]="userName"
            placeHolder="{{'SHARED.REPORTS.AGENT_NAME_MIN_CHARS' | translate }}">
          </ng-autocomplete>
  
          <ng-template #itemTemplate let-item>
            <a [innerHTML]="item"></a>
          </ng-template>
  
          <ng-template #notFoundTemplate let-notFound>
            <div [innerHTML]="this.agentNameNotFoundMessage"></div>
          </ng-template>
        </div>
      </div>
  <!-- From Region -->
  <div class="form-group">
    <label for="ddlFromRegionOriginId">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.FromRegion' | translate}}</label>
    <select [(ngModel)]="fromRegionId" class="form-control" 
      id="ddlFromRegionOriginId">
      <option value="" selected>{{'Choose'| translate}}</option>
      <option *ngFor="let fromRegion of uniqueFromRegions" [value]="fromRegion?.Id">
        {{fromRegion?.NameEN}}
      </option>
    </select>
  </div>

  <!-- To Region -->
  <div class="form-group">
    <label for="ddlToRegionOriginId">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.ToRegion' | translate}}</label>
    <select [(ngModel)]="toRegionId" class="form-control" 
      id="ddlToRegionOriginId">
      <option value="" selected>{{'Choose'| translate}}</option>
      <option *ngFor="let toRegion of uniqueToRegions" [value]="toRegion?.Id">
        {{toRegion?.NameEN}}
      </option>
    </select>
  </div>

      <!-- Last Country of Origin -->
      <div class="form-group">
        <label for="ddlLastCountryOriginId">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.LastCountryOfOrigin' | translate}}</label>
        <select [(ngModel)]=" this.fromCountryId" class="form-control" (change)="onLastCountrySelect($event.target.value)"
          id="ddlLastCountryOriginId">
          <option value="" selected>{{'Choose'| translate}}</option>
          <option *ngFor="let country of countries" [value]="country?.Id">
            {{country?.NameEN}}
          </option>
        </select>
      </div>
      <!-- Last Port of Origin -->
      <div class="form-group">
        <label for="ddlLastPortOriginId">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.LastPortOfOrigin' | translate}}</label>
        <select [(ngModel)]="fromPortId" class="form-control" id="ddlLastPortOriginId">
          <option value="" selected>{{'Choose'| translate}}</option>
          <option *ngFor="let lastPortOrigin of lastPortsOrigin" [value]="lastPortOrigin?.Id">
            {{lastPortOrigin?.NameEN}}
          </option>
        </select>
      </div>
  
  
      <!-- First Country of Destination -->
      <div class="form-group">
        <label for="ddlFirstCountryDestinationId">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.FirstCountryOfDestination' | translate}}</label>
        <select class="form-control" [(ngModel)]=" this.toCountryId" (change)="onFirstCountrySelect($event.target.value)"
          id="ddlFirstCountryDestinationId">
          <option value="" selected>{{'Choose'| translate}}</option>
          <option *ngFor="let country of countries" [value]="country?.Id">
            {{country?.NameEN}}
          </option>
        </select>
      </div>
      <!-- First Port of Destination -->
      <div class="form-group">
        <label for="ddlFirstPortDestinationId">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.FirstPortOfDestination' | translate}}</label>
        <select [(ngModel)]="toPortId" class="form-control" id="ddlFirstPortDestinationId">
          <option value="" selected>{{'Choose'| translate}}</option>
          <option *ngFor="let firstPortDestination of firstPortsDestination" [value]="firstPortDestination?.Id">
            {{firstPortDestination?.NameEN}}
          </option>
        </select>
      </div>
      

      <!-- Sail Directions -->
      <div class="form-group">
        <label for="ddlSailDirections">{{ 'SHARED.REPORTS.EBOOKING_REPORT.DIRECTIONS' | translate}}</label>
        <select [(ngModel)]=" this.directionId" class="form-control" id="ddlSailDirections">
            <option value="">--- {{'SHARED.REPORTS.EBOOKING_REPORT.ALL_DIRECTIONS' | translate}} ---</option>
            <option *ngFor="let direction of sailDirections" value="{{direction?.Id}}">
                {{direction?.Direction}}
            </option>
        </select>
    </div>


      <!-- Decision Feedback Date From -->
      <div class="form-group">
        <label
          for="txtDecisionFeedbackDateFrom">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.DECISION_FEEDBACK_DATE_FROM' | translate}}</label>
        <input class="form-control" id="txtDecisionFeedbackDateFrom" name="txtDecisionFeedbackDateFrom" autocomplete="off"
          #input="bsDatepicker" [(ngModel)]="decisionFeedbackDateFrom" bsDatepicker [minDate]='null'
          [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
        <div class="red" *ngIf="showDecisionFeedbackDateFromGreaterThanTodayDateMessage">
          {{'SHARED.REPORTS.CIRCULARS_REPORT.DECISION_FEEDBACK_FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
        </div>
        <div class="red" *ngIf="showDecisionFeedbackFromDateGreaterThanDecisionFeedbackDateToMessage" >
          {{'SHARED.REPORTS.CIRCULARS_REPORT.DECISION_FEEDBACK_FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
        </div>
      </div>

      <!-- Decision Feedback Date To -->
      <div class="form-group">
        <label
          for="txtDecisionFeedbackDateTo">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.DECISION_FEEDBACK_DATE_TO' | translate}}</label>
        <input class="form-control" id="txtDecisionFeedbackDateTo" name="txtDecisionFeedbackDateTo" autocomplete="off"
          #input="bsDatepicker" [(ngModel)]="decisionFeedbackDateTo" bsDatepicker [minDate]='null'
          [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
      </div>

      <!--Refunded -->
      <!-- <div  class="form-group">
          <label for="RefundedCheckbox">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.Refunded' | translate }}</label>
        <div class="custom-checkbox">
          <input type="checkbox"  name="RefundedCheckbox" id="RefundedCheckbox"
          [(ngModel)]="isrefunded">
          <label for="RefundedCheckbox">Yes</label>
        </div>
      </div> -->
    
      <!--Ship Passed -->
      <!-- <div  class="form-group">
          <label for="ShipPassedCheckbox">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.ShipPassed' | translate }}</label>
        <div class="custom-checkbox">
          <input type="checkbox"  name="ShipPassedCheckbox" id="ShipPassedCheckbox"
          [(ngModel)]="isPassed">
          <label for="ShipPassedCheckbox">Yes</label>
        </div>
      </div> -->

      <!--Closed Requests -->
      <!-- <div  class="form-group">
        <label for="ClosedRequestsCheckbox">{{ 'SHARED.REPORTS.CIRCULARS_REPORT.ClosedRequests' | translate }}</label>
      <div class="custom-checkbox">
        <input type="checkbox"  name="ClosedRequestsCheckbox" id="ClosedRequestsCheckbox" [(ngModel)]="isClosed">
        <label for="ClosedRequestsCheckbox">Yes</label>
      </div>
    </div>  -->
  
  
    </div>
   
  
    <div class="btns-holder text-center">
      <input type="button" class="btn btn-primary SCAcustomBtn" (click)="getCircularsReportData()"
        value="{{ 'SHARED.Search' | translate}}" />
      <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetFilters()"
        value="{{ 'SHARED.ResetSearch' | translate}}" />
       <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="EconomicExport()"
        value="{{ 'SHARED.REPORTS.EconomicExport' | translate}}" />
      <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="MeasurementExport()"
        value="{{ 'SHARED.REPORTS.MeasurementExport' | translate}}" />
    </div>
  </div>
  <app-grid-view #CircularsReport [HasMenu]="HasMenu"></app-grid-view>
</div>
